import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { schenectadyConfig } from "./data";

export default function SchenectadyPage() {
  return <CityPageTemplate config={schenectadyConfig} />;
}